import {
  Nav,
  NavItem,
  NavItemProps,
  NavList,
  PageSidebar,
  PageSidebarBody,
} from "@patternfly/react-core";
import { PropsWithChildren, MouseEvent as ReactMouseEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHref, useLinkClickHandler } from "react-router-dom";
import { ExtendedRoute, routes } from "./routes";

type NavLinkProps = NavItemProps & {
  path?: string;
};

const NavLink = ({
  id,
  path,
  isActive,
  children,
  onClick,
}: PropsWithChildren<NavLinkProps>) => {
  const menuItemPath = path!;
  const href = useHref(menuItemPath);
  const handleClick = useLinkClickHandler(menuItemPath);

  return (
    <NavItem
      id={id}
      to={href}
      onClick={(e, itemId, groupId, to) =>
        {
          onClick?.(e, itemId, groupId, to);
          handleClick(
            e as unknown as ReactMouseEvent<HTMLAnchorElement, MouseEvent>
          );
        }
      }
      isActive={isActive || href === window.location.pathname}
    >
      {children}
    </NavItem>
  );
};

export const PageNav = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState<string | undefined>();

  return (
    <PageSidebar>
      <PageSidebarBody>
        <Nav>
          <NavList>
            {(routes[0].children as ExtendedRoute[])
              ?.map(({ path, label }) => (
                <NavLink
                  id={`nav-link-${label.toLowerCase()}`}
                  key={path}
                  path={path}
                  isActive={path === active}
                  onClick={() => setActive(path)}
                >
                  {t(label)}
                </NavLink>
              ))}
          </NavList>
        </Nav>
      </PageSidebarBody>
    </PageSidebar>
  );
};
